var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'form-item',
  ("form-item--" + _vm.type),
  _vm.type !== 'checkbox' && _vm.type !== 'radio' ? "form-item--text" : '',
  _vm.type === 'select' ? 'form-item--icon' : '',
  _vm.type === 'search' ? 'form-item--icon' : '',
  _vm.type === 'search' ? 'form-item--icon-search' : '',
  _vm.icon ? ("form-item--icon form-item--icon-" + _vm.icon) : '' ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }